let showDialog = null;

export const registerDialogHost = (handler) => {
  showDialog = handler;
  return () => {
    if (showDialog === handler) showDialog = null;
  };
};

const fallbackAlert = (message) => {
  // Last-resort fallback only if the host has not mounted yet.
  console.warn(message);
  return Promise.resolve();
};

export const alertDialog = (message, options = {}) => {
  if (!showDialog) return fallbackAlert(message);
  return showDialog({
    type: "alert",
    title: options.title || "Notice",
    message,
    confirmLabel: options.confirmLabel || "OK",
    variant: options.variant || "info",
  });
};

export const confirmDialog = (message, options = {}) => {
  if (!showDialog) return Promise.resolve(false);
  return showDialog({
    type: "confirm",
    title: options.title || "Confirm Action",
    message,
    confirmLabel: options.confirmLabel || "Confirm",
    cancelLabel: options.cancelLabel || "Cancel",
    variant: options.variant || "danger",
  });
};
